import _ from "lodash";
import React, { useState } from "react";
import ACLStore from "lib/aclStore";
import { ENABLE_AUTH_AND_EVAL_REVAMP } from "Constants/permissionConstants";
import TagSnp from "AppComponents/TagSnpModalV2/TagSnp";
import TagSnpV2 from "AppComponents/TagSnpModalV4/TagSnp";
import { getPracticeListDetailsFromCache } from "SnP_v2/modules/SnPGraphqlHelpers";
import {
  getTransformedTaggedPractices,
  isPortfolioParityEnabledAndIsJournalRoute,
} from "Post/utils";
import { getUpdatedTaggedPractices } from "SnP_v2/modules/SnPUtils";
import { connect } from "react-redux";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";

const TagPracticesV2 = props => {
  const { screenPanelProps, userId } = props;
  const {
    postDetails,
    onCloseClick,
    updatePost,
    curriculumProgramId,
  } = screenPanelProps;

  const [currentStepIndex, setCurrentStepIndex] = useState(0);

  const { taggedPractices, title, attachments } = postDetails;
  const itemId = _.get(postDetails, "id", "");
  const itemType = "POST";

  const updateTaggedPractices = ({
    evaluationCycle,
    addedPractices,
    removedPractices,
  }) => {
    const addedPracticesDetails = _.map(addedPractices, id => {
      return { ...getPracticeListDetailsFromCache({ id }) };
    });

    const updatedTaggedPractices = getUpdatedTaggedPractices({
      taggedPractices: taggedPractices,
      evaluationCycleId: evaluationCycle.id,
      addedPractices: addedPracticesDetails,
      removedPractices: _.map(removedPractices, id => ({ id })),
      userId: userId,
    });

    updatePost({
      taggedPractices: updatedTaggedPractices,
    });
  };
  const isAuthAndEvalRevampEnabled = ACLStore.can(ENABLE_AUTH_AND_EVAL_REVAMP);

  return isAuthAndEvalRevampEnabled ? (
    <TagSnpV2
      curriculumProgramId={
        curriculumProgramId || _.get(postDetails, "curriculumProgramId")
      }
      itemId={itemId}
      itemType={itemType}
      itemTitle={title}
      closeModal={onCloseClick}
      updateTaggedPractices={updateTaggedPractices}
      taggedPractices={getTransformedTaggedPractices({
        taggedPractices,
      })}
      currentStepIndex={currentStepIndex}
      setCurrentStepIndex={setCurrentStepIndex}
    />
  ) : (
    <TagSnp
      curriculumProgramId={
        curriculumProgramId || _.get(postDetails, "curriculumProgramId")
      }
      itemId={itemId}
      itemType={itemType}
      itemTitle={title}
      closeModal={onCloseClick}
      thumbnailData={{ attachments }}
      updateTaggedPractices={updateTaggedPractices}
      taggedPractices={getTransformedTaggedPractices({
        taggedPractices,
      })}
      showDesignV2={isPortfolioParityEnabledAndIsJournalRoute()}
    />
  );
};

const mapStateToProps = state => {
  const userInfo = getUserInfo();
  return {
    userId: userInfo.id,
  };
};

export default connect(mapStateToProps)(TagPracticesV2);
